import { useEffect, useRef } from 'react';

import { trackEvent } from 'utils/analyticsUtils';

function useTrackLoader({ enabled = false, instance }) {
    // Using Date.now() instead of performance.now() for simplicity.
    // It's accurate enough for our purposes.
    const startTimeRef = useRef(enabled ? Date.now() : null);

    // This will track on rerenders, but that's acceptable since most loader implementations
    // don't (re)render frequently enough to cause significant tracking spam.
    useEffect(() => {
        if (!enabled) {
            return undefined;
        }

        // track on unmount
        return () => {
            try {
                const duration = (Date.now() - startTimeRef.current) / 1000;

                trackEvent('loading icon rendered', {
                    duration_seconds: duration,
                    instance,
                    path: window.location.pathname,
                });
            } catch {
                // swallow errors
            }
        };
    }, [enabled, instance]);
}

export default useTrackLoader;
